import { getDapiRootUrl } from './globalConfiguration';

export const utils = {
  parseLabel: function (text, state) {
    try {
      if (text.includes('{') && text.includes('}')) {
        let stateKey = '';
        let start = false;
        let uppercase = false;
        for (let i = 0; i < text.length; i++) {
          if (text[i] == '{') {
            start = true;
            i++;
            if (text[i] == 'u' && text[i + 1] == "'") {
              uppercase = true;
              i += 2;
            }
          }
          if (start) {
            if (text[i] == '}') {
              break;
            }
            stateKey += text[i];
          }
        }
        if (state && state.globalState && state.globalState[stateKey]) {
          let replaceValue = state.globalState[stateKey];
          if (uppercase) {
            replaceValue = replaceValue.charAt(0).toUpperCase() + replaceValue.slice(1);
          }
          const leftSplit = text.split('{');
          const rightSplit = text.split('}');
          return `${leftSplit[0]}${replaceValue}${rightSplit[1]}`;
        } else {
          return text;
        }
      } else {
        return text;
      }
    } catch (e) {
      //console.log(e)
      return text;
    }
  },
};

/** Gets validate endpoint */
export const getValidateEndpoint = (endpoint) => {
  return getEndpoint('validate', endpoint);
};

/** Gets addresses endpoint */
export const getAddressesEndpoint = (uuid) => {
  return getEndpoint('addresses', uuid);
};

/** Gets street search endpoint */
export const getStreetSearchEndpoint = () => {
  return getEndpoint('search', 'streets');
};

/** Gets addresses search endpoint */
export const getAddressesSearchEndpoint = () => {
  return getEndpoint('search', 'addresses');
};

/** Gets postcodes search endpoint */
export const getPostcodesSearchEndpoint = () => {
  return getEndpoint('search', 'postcodes');
};

/** Gets municipalities autocomplete endpoint */
export const getAutoCompleteMunicipalitiesEndpoint = () => {
  return getEndpoint('search', 'municipalities');
};

/** Gets verify autocomplete endpoint */
export const getVerifyEndpoint = (endpoint) => {
  return getEndpoint('verify', endpoint);
};

/** Gets endpoint based on type and endpoint type */
export const getEndpoint = (type, endpoint) => {
  return `${getDapiRootUrl()}/${type}/${endpoint}`;
};
